// import {ScrollTrigger} from 'gsap/ScrollTrigger';
// import helpers from '../helpers';
//
// gsap.registerPlugin(ScrollTrigger);
//
// function init() {
// 	helpers.$siteContainer.removeClass('is-hidden');
//
// 	const footerHeight = helpers.$footer.outerHeight(true);
//
// 	function animatedImage($openingImage, $loopedImage) {
// 		const openingFramesCount = 240;
// 		const openingFramesDelay = 2;
// 		const openingAnimateTime = openingFramesCount * openingFramesDelay * 10 - 30;
//
// 		$openingImage.style.display = 'block';
// 		$loopedImage.style.display = 'none';
//
// 		// Opening animation is ended timeout
// 		setTimeout(() => {
// 			$openingImage.style.display = 'none';
// 			// $loopedImage.style.marginTop = '-15px';
// 			// $loopedImage.style.transform = 'scale(0.83)';
// 			$loopedImage.style.display = 'block';
// 		}, openingAnimateTime);
// 	}
//
// 	function checkAnimatedImageIsLoaded() {
// 		const $container = document.querySelector('.js-animated-image');
// 		const $openingImage = $container.querySelector('.js-animated-image__opening');
// 		const $loopedImage = $container.querySelector('.js-animated-image__looped');
//
// 		$openingImage.addEventListener('load', () => {
// 			if ($loopedImage.complete) {
// 				animatedImage($openingImage, $loopedImage);
// 			} else {
// 				$loopedImage.addEventListener('load', () => {
// 					animatedImage($openingImage, $loopedImage);
// 				});
// 			}
// 		});
// 	}
//
// 	function bioScroll() {
// 		const scrollBottom = helpers.$document.height() - (helpers.$window.scrollTop() + helpers.$window.height());
// 		if (scrollBottom >= footerHeight) {
// 			$('.main__bio').css('bottom', '').addClass('with-shadow');
// 		}
//
// 		if (scrollBottom < footerHeight) {
// 			$('.main__bio').css('bottom', `${footerHeight - scrollBottom + 9}px`).removeClass('with-shadow');
// 		}
// 	}
//
// 	function girlScroll() {
// 		const scrollBottom = helpers.$document.height() - (helpers.$window.scrollTop() + helpers.$window.height());
// 		if (scrollBottom >= footerHeight) {
// 			gsap.to('.main__girl', 0.15, {
// 				y: 0,
// 			});
// 		}
//
// 		if (scrollBottom < footerHeight) {
// 			gsap.to('.main__girl', 0.15, {
// 				y: -(footerHeight - scrollBottom + 30),
// 			});
// 		}
// 	}
//
// 	gsap.from('.main__container, .dom-gl', {
// 		opacity: 0,
// 		y: 40,
// 		duration: 2,
// 		ease: 'Power4.out',
// 	});
//
// 	gsap.from('.main__girl', {
// 		opacity: 0,
// 		y: 40,
// 		delay: 0.5,
// 		duration: 2,
// 		ease: 'Power4.out',
// 	});
//
// 	gsap.from('.lead', {
// 		opacity: 0,
// 		y: 40,
// 		delay: 0.5,
// 		duration: 1.5,
// 		onComplete() {
// 			gsap.fromTo('.lead', {}, {
// 				scrollTrigger: {
// 					trigger: '.lead',
// 					start: 'center top+=250',
// 					end: '+=150',
// 					scrub: 0.5,
// 				},
// 				opacity: helpers.isMobile ? 0.5 : 0,
// 				y: helpers.isMobile ? 0 : -45,
// 			});
// 		},
// 	});
//
// 	gsap.timeline().from('.lead__text', {
// 		opacity: 0,
// 		y: 45,
// 		delay: 0.5,
// 		duration: 1.5,
// 	})
// 		.from('.header', {
// 			opacity: 0,
// 			y: -45,
// 			duration: 1,
// 			onComplete() {
// 				$('.header').addClass('is-loaded');
// 			},
// 		})
// 		.from('.main__item', {
// 			opacity: 0,
// 			y: 45,
// 			duration: 1.5,
// 			onComplete() {
// 				gsap.fromTo('.main__item', {}, {
// 					scrollTrigger: {
// 						trigger: '.lead',
// 						start: 'center top',
// 						end: '+=100',
// 						scrub: 0.5,
// 					},
// 					opacity: 0,
// 					y: -45,
// 				});
// 			},
// 		});
//
// 	gsap.from('.main__mobile-items', {
// 		opacity: 0,
// 		y: 45,
// 		duration: 1.5,
// 		onComplete() {
// 			gsap.fromTo('.main__mobile-items', {}, {
// 				scrollTrigger: {
// 					trigger: '.lead',
// 					start: 'center top',
// 					end: '+=300',
// 					scrub: 0.5,
// 				},
// 				opacity: 0,
// 				y: -45,
// 			});
// 		},
// 	});
//
// 	gsap.from('.main__info', {
// 		opacity: 0,
// 		y: 45,
// 		duration: 1.5,
// 		onComplete() {
// 			gsap.fromTo('.main__info', {}, {
// 				scrollTrigger: {
// 					trigger: '.main__mobile-items',
// 					start: 'center top',
// 					end: '+=300',
// 					scrub: 0.5,
// 				},
// 				opacity: 0,
// 				y: -45,
// 			});
// 		},
// 	});
//
// 	gsap.from('.main__warning', 0.5, {
// 		scrollTrigger: {
// 			trigger: '.main__items',
// 			start: 'top top+=250',
// 			toggleActions: 'play none none reverse',
// 		},
// 		opacity: 0,
// 	});
//
// 	gsap.from('.main__capsule--3', {
// 		opacity: 0,
// 		y: -100,
// 		delay: 2,
// 		duration: 1.5,
// 	});
//
// 	gsap.from('.main__capsule--1', {
// 		y: -560,
// 		duration: 2,
// 		ease: 'Power4.out',
// 	});
//
// 	gsap.from('.main__capsule--2', {
// 		y: -260,
// 		duration: 2,
// 		ease: 'Power4.out',
// 	});
//
// 	checkAnimatedImageIsLoaded();
// 	bioScroll();
// 	girlScroll();
//
// 	helpers.$window.on('scroll', bioScroll);
// 	helpers.$window.on('scroll', girlScroll);
// }
//
// export default {
// 	init,
// };
